/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1SsoimageIdQueryResponse,
  GetApiV1SsoimageIdPathParams,
  GetApiV1SsoimageId401,
  GetApiV1SsoimageId404,
  GetApiV1SsoimageId500,
} from "../../types/SSOImageController/GetApiV1SsoimageId.ts";

function getGetApiV1SsoimageIdUrl(id: GetApiV1SsoimageIdPathParams["id"]) {
  const res = { method: "GET", url: `/api/v1/ssoimage/${id}` as const };
  return res;
}

/**
 * @description Retorna uma imagem SSO ativa com seus idiomas pelo Id. **(Requer Authorization para autenticação)**
 * @summary Buscar imagem SSO por Id (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage/:id}
 */
export async function getApiV1SsoimageId(
  id: GetApiV1SsoimageIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1SsoimageIdQueryResponse,
    ResponseErrorConfig<
      GetApiV1SsoimageId401 | GetApiV1SsoimageId404 | GetApiV1SsoimageId500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1SsoimageIdUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
